import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listDataAlerts,
  listAlertRules,
  acknowledgeAlert,
  resolveAlert,
  createAlertRule,
  updateAlertRule,
  deleteAlertRule,
} from "@/api/client";

interface AlertFilters {
  studyId?: string;
  severity?: string;
  includeResolved?: boolean;
  limit?: number;
}

export function useAlerts(filters?: AlertFilters) {
  return useQuery({
    queryKey: ["alerts", filters],
    queryFn: () => listDataAlerts(filters ?? {}),
    staleTime: 15 * 1000,
  });
}

export function useAlertRules() {
  return useQuery({
    queryKey: ["alertRules"],
    queryFn: listAlertRules,
    staleTime: 2 * 60 * 1000,
  });
}

export function useAcknowledgeAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acknowledgeAlert,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alerts"] });
    },
  });
}

export function useResolveAlert() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resolveAlert,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alerts"] });
    },
  });
}

export function useCreateAlertRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAlertRule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alertRules"] });
    },
  });
}

export function useUpdateAlertRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAlertRule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alertRules"] });
    },
  });
}

export function useDeleteAlertRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAlertRule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["alertRules"] });
    },
  });
}
